import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { IMAGE_SRC } from '../shared/shared-constants';
import {
  BANNER,
  BANNER_MESSAGE_TYPE,
  FILE_UPLOAD_RESPONSE,
} from './banner.constants';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: false,
})
export class BannerComponent {
  @Input() drawerOpen!: boolean;
  @Output() emitExit = new EventEmitter();

  readonly IMAGES = IMAGE_SRC;
  readonly BANNER_TYPE = BANNER;
  readonly BANNER_MESSAGE_TYPE = BANNER_MESSAGE_TYPE;
  readonly BANNER_400_MESSAGE = this.commonUtils.unknownBannerText();
  readonly bannerType = this.commonUtils.bannerType();
  readonly FILE_UPLOAD_RESPONSE = FILE_UPLOAD_RESPONSE;
  deviceNameFromMessage: string = '';
  constructor(public readonly commonUtils: CommonUtils) {}

  ngOnInit() {
    // Fetching Device Name from message which is the second element of the array
    // Splitting the device name to remove the 'Unique device name for this upload' part from message
    this.deviceNameFromMessage =
      this.commonUtils.fileUploadResponse?.message[1]?.split(':')[1] ?? '';
  }

  clickExit() {
    this.emitExit.emit();
  }
}
